import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEnergyDeliveredCell } from './emsp-bo-charging-session-list-energy-delivered.cell';
import { EmspBoChargingSessionListEnergyDeliveredHeader } from './emsp-bo-charging-session-list-energy-delivered.header';

export const EmspBoChargingSessionListEnergyDeliveredColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['energyDelivered']
> = {
  enableSorting: true,
  header: EmspBoChargingSessionListEnergyDeliveredHeader,
  cell: EmspBoChargingSessionListEnergyDeliveredCell,
  meta: { maxWidth: '90px', width: '85px' },
};
